<template>
  <div id="resource-card">
    <b-card
      header-tag="header"
      footer-tag="footer"
      border-variant="secondary"
      header-border-variant="secondary"
    >
      <template v-slot:header>
        <h6 class="mb-0">
          <b-icon-justify class="handle-resource"></b-icon-justify>
          <em> Resource:</em>
          {{resource.name}}
        </h6>
      </template>

      <b-card-text>
        <b>Description:</b>
        <br />
        {{ resource.description }}
      </b-card-text>
      <b-card-text>This resource has {{resource.datapoints.length}} datapoints</b-card-text>

      <template v-slot:footer>
        <b-button-group class="p-1" size="sm">
          <b-button
            :id="'edit-resource'+ resource.category +'-'+ resource.id"
            pill
            variant="success"
            @click="$emit('handle-resource-modal', resource, category)"
          >
            <b-icon-pencil-square></b-icon-pencil-square>Edit Resource
          </b-button>

          <b-button pill class="ml-1" variant="danger" @click="deleteResource(resource)">
            <b-icon-trash></b-icon-trash>Delete Resource
          </b-button>
          <b-button
            pill
            class="ml-1"
            variant="warning"
            @click="$emit('nav-to-datapoint', resource, category)"
          >
            <b-icon-link45deg></b-icon-link45deg>Manage Datapoints
          </b-button>
        </b-button-group>
      </template>
    </b-card>
  </div>
</template>


<script>
import {
  BIconTrash,
  BIconLink45deg,
  BIconPencilSquare,
  BIconJustify,
} from "bootstrap-vue";

export default {
  components: {
    BIconTrash,
    BIconLink45deg,
    BIconPencilSquare,
    BIconJustify,
  },

  props: {
    resource: Object,
    category: Object,
  },

  methods: {
    deleteResource: function (resource) {
      let deleteMessage = `Are you sure you want to delete ${resource.name} sure?`;
      if (resource.datapoints.length > 0) {
        deleteMessage =
          deleteMessage +
          ` This wil ALSO delete ${resource.datapoints.length} datapoints!!`;
      }
      this.$confirm({
        message: deleteMessage,
        button: {
          no: "No, don't!",
          yes: "Yes really!",
        },
        callback: (confirm) => {
          if (confirm) {
            let deleted = resource.name;
            this.$http
              .delete(`${this.$API_URL}resources/${resource.id}`)
              .then((response) => {
                this.$bvToast.toast(
                  `${deleted} and all related elements deleted successfully. ${response.status}`,
                  {
                    title: "Deletion Succeeded!",
                    variant: "success",
                    toaster: "b-toaster-top-center",
                    autoHideDelay: 5000,
                  }
                );
                this.$emit("refresh-list");
              })
              .catch((response) => {
                this.$bvToast.toast(
                  `An ${response} has occured. An email has been sent to detailing the problem, but please try again!`,
                  {
                    title: "Error during submission",
                    variant: "danger",
                    toaster: "b-toaster-top-center",
                    autoHideDelay: 5000,
                  }
                );
              });
          }
        },
      });
    },
  },
};
</script>
<style scoped>
.bg-custom-4 {
  background-color: #80d0c7;
}
</style>